import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import useState from "react-usestateref";
import { PlusIcon } from "@heroicons/react/solid";
import { MenuIcon, XIcon } from "@heroicons/react/outline"; // Added
import { Menu, Transition } from "@headlessui/react";
import "./ChatRow.css";
import {
  DocumentIcon,
  PhotographIcon,
  VideoCameraIcon,
  CodeIcon,
  MicrophoneIcon,
} from "@heroicons/react/solid";
import { ShimmerCategoryItem } from "react-shimmer-effects";
import { socket, SocketContext } from "../services.js/socket";
import SearchBar from "./SearchBar";
import CreateGroupModal from "./CreateGroupModal";
import axios from "axios";
import backendService from "../services.js/backendService";
import TimeAgo from "timeago-react";
import { ToastContainer, toast } from "react-toastify";
import toastProp from "../global/toastProps";
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from "react-query";
import ReactTooltip from "react-tooltip";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const optimizeURL = (URL) => {
  const parametre = "upload/q_auto:best";
  return URL.replace("upload", parametre);
};
function QuipComponent() {
  return Array.apply(null, { length: 5 }).map((e, i) => (
    <ShimmerCategoryItem
      key={i}
      hasImage
      imageType="circular"
      imageWidth={56}
      imageHeight={56}
      contentCenter
      text
    />
  ));
}
const handleRecents = async () => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_URL}/getgroups`, {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": backendService.getToken(),
      },
    });
    return res.data.groups;
  } catch (error) {
    console.log(error);
  }
};
function Groups(props) {
  const navigation = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [groups, setGroups] = useState([]);
  const socket = useContext(SocketContext);
  const [selected, setSelected, selectedRef] = useState(
    props.currentOpenedConvo
  );
  const [recents, setRecents] = useState([]);
  const { data, status, refetch } = useQuery("grouprecents", handleRecents, {
    retry: true,
  });
  const [searchText, setSearchText, searchTextRef] = useState("");
  const getSearchText = (data) => {
    setSearchText(data);
 
  };
  const openModal = (data) => {
    setShowModal(data);
  };
  useEffect(() => {
    refetch();
  }, [props.clicked]);
  useEffect(() => {
    refetch();
  }, [props.start]);
  useEffect(() => {
    socket.on("recentsUpdate", (data) => {
      refetch();
    });
  }, []);
  useEffect(() => {
    if (data) {
      setRecents(data);
    }
  }, [data]);
  useEffect(() => {
    if (searchTextRef.current.length > 0) {
      //update setRecents to filter by searchText
      setRecents(
        recents?.filter((item) =>
          item.groupName
            .toLowerCase()
            .includes(searchTextRef.current.toLowerCase())
        )
      );
    } else {
      setRecents(data);
    }
  }, [searchText]);
  const createGroupModal = () => {
    return <CreateGroupModal showModal={openModal} />;
  };

  function truncate(string, n) {
    return string?.length > n ? string.substr(0, n - 1) + "..." : string;
  }
  const checkUnread = (unread) => {
    unread.forEach((element) => {
      if (element.count === 1) {
        return true;
      }
    });
    return false;
  };
  useEffect(() => {
    refetch();
  }, [showModal]);
  if (status === "error") {
    return <p>There was an error</p>;
  }
  return (
    <>
      {
        <Transition
          enter="ease-in duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-out duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          show={showModal}
        >
          {createGroupModal()}
        </Transition>
      }
      <div className=" w-full h-screen">
        <ReactTooltip delayShow={500} delayHide={100} />
        <div className=" h-[60px] bg-background flex items-center px-3 sm:px-5">
          {/* Hamburger Menu Button - Mobile Only */}
          {props.setIsMobileMenuOpen && (
            <div className="sm:hidden mr-3">
              <button onClick={() => props.setIsMobileMenuOpen(!props.isMobileMenuOpen)} className="p-1 rounded-md text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500">
                {props.isMobileMenuOpen ? <XIcon className="h-6 w-6" /> : <MenuIcon className="h-6 w-6" />}
              </button>
            </div>
          )}
          <h3 className="text-primary text-xl sm:text-2xl font-robo flex-grow min-w-0 whitespace-nowrap overflow-hidden text-ellipsis">Groups</h3>
          <div className="h-7 w-7 flex items-center justify-center  cursor-pointer text-palette_color1 hover:bg-palette_color1 hover:text-palette_color2 hover:rounded-full">
            <PlusIcon
              className="h-5 w-5 "
              data-tip="Create Group"
              data-place="bottom"
              aria-hidden="true"
              onClick={() => setShowModal(true)}
            />
          </div>
        </div>
        <SearchBar getRecentSearchText={getSearchText} />
        {status === "loading" ? (
          <div className="pl-4"> <QuipComponent /></div>
        ) : (
          <div className="h-[80%] overflow-y-auto scrollbar-track-pallete_color3 overflow-x-hidden scroll-smooth chat__container ">
            {searchTextRef.current.length > 0 ? (
              recents?.length > 0 ? (
                recents.map((group, i) => (
                  <div
                    key={group._id}
                    onClick={() => {
                      setSelected(group._id);
                      props.getCurrentOpenedConvo(group._id);
                      props.getCurrent(group);
                      navigation(`/home/groups/${group._id}`);
                      refetch();
                    }}
                    onLoad={() => {
                      if (selectedRef.current === group._id) {
                        props.getCurrent(group);
                      }
                    }}
                    className={classNames(
                      selectedRef.current === group._id
                        ? "text-white bg-palette_color1"
                        : "",
                      "flex cursor-pointer h-[65px] shadow  rounded-lg hover:bg-[#254441]  transition-all duration-500 hover:text-white border-secondary m-3 "
                    )}
                  >
                    <div className="flex flex-none items-center px-3 sm:px-4 ">
                      <div className="">
                        <img
                          alt="Profile"
                          className="rounded-full h-[40px] w-[40px] cursor-pointer"
                          src={
                            group.profilePicture
                              ? optimizeURL(group.profilePicture.filePath)
                              : require("../assets/people.png")
                          }
                        />
                      </div>
                    </div>
                    <div className="flex flex-grow min-w-0 items-center px-2 sm:px-3 ">
                      <div className="w-full   ">
                        <div className="justify-center items-center">
                          <div className="flex justify-between items-center mr-2 pb-1">
                            <h3 className="text-primary text-md antialiased  font-robo">
                              {group.groupName}
                            </h3>
                            <h3 className=" text-xs antialiased font-robo">
                              <TimeAgo datetime={group.lastUpdated} />
                            </h3>
                          </div>
                          <div className="flex justify-between items-center mr-4 -mt-1">
                            {group?.lastMessageType === "text" ? (
                              <p className=" font-robo text-sm opacity-70 ">
                                {truncate(group.lastMessage, 35)}
                              </p>
                            ) : group?.lastMessageType === "file" ? (
                              <div className="flex justify-between items-center">
                                <DocumentIcon className="h-4 w-4  right-0 cursor-pointer opacity-70" />
                                <p className=" text-xs font-robo ">File</p>
                              </div>
                            ) : group?.lastMessageType === "image" ? (
                              <div className="flex justify-between items-center">
                                <PhotographIcon className="h-4 w-4  right-0 cursor-pointer opacity-70" />
                                <p className=" text-xs font-robo ">Image</p>
                              </div>
                            ) : group?.lastMessageType === "video" ? (
                              <div className="flex justify-between items-center">
                                <VideoCameraIcon className="h-4 w-4   right-0 cursor-pointer opacity-70" />
                                <p className=" text-xs font-robo ">Video</p>
                              </div>
                            ) : group?.lastMessageType === "audio" ? (
                              <div className="flex justify-between items-center">
                                <MicrophoneIcon className="h-4 w-4   right-0 cursor-pointer opacity-70" />
                                <p className=" text-xs font-robo ">Audio</p>
                              </div>
                            ) : group.lastMessage &&
                              group?.lastMessageType?.includes("code") ? (
                              <div className="flex justify-between items-center opacity-70">
                                <CodeIcon className="h-4 w-4  right-0 cursor-pointer" />
                                <p className=" text-xs font-robo ">
                                  {truncate(group.lastMessage, 15)}
                                </p>
                              </div>
                            ) : (
                              <p className=" text-xs"></p>
                            )}
                            {selectedRef.current !== group._id &&
                            checkUnread(group.unread) ? (
                              <div class=" h-2 w-2  border-white rounded-full bg-[#44ff00]  mr-4"></div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="flex justify-center items-center">
                  <p className="text-primary text-xl font-semibold font-robo mt-10">
                    No Search Result
                  </p>
                </div>
              )
            ) : data?.length > 0 ? (
              data.map((group) => (
                <div
                  key={group._id}
                  onClick={() => {
                    setSelected(group._id);
                    props.getCurrentOpenedConvo(group._id);
                    props.getCurrent(group);
                    navigation(`/home/groups/${group._id}`);
                    refetch();
                  }}
                  onLoad={() => {
                    if (selectedRef.current === group._id) {
                      props.getCurrent(group);
                    }
                  }}
                  className={classNames(
                    selectedRef.current === group._id
                      ? "text-white bg-palette_color1"
                      : "",
                    "flex cursor-pointer h-[65px] shadow  rounded-lg hover:bg-[#254441]  transition-all duration-500 hover:text-white border-secondary m-3 "
                  )}
                >
                  <div className="flex flex-none items-center px-3 sm:px-4 ">
                    <div className="">
                      <img
                        alt="Profile"
                        className="rounded-full h-[40px] w-[40px] cursor-pointer"
                        src={
                          group.profilePicture
                            ? optimizeURL(group.profilePicture.filePath)
                            : require("../assets/people.png")
                        }
                      />
                    </div>
                  </div>
                  <div className="flex flex-grow min-w-0 items-center px-2 sm:px-3 ">
                    <div className="w-full   ">
                      <div className="justify-center items-center">
                        <div className="flex justify-between items-center mr-2">
                          <h3 className="text-primary text-md antialiased  font-robo">
                            {group.groupName}
                          </h3>
                          <h3 className=" text-xs antialiased font-robo">
                            <TimeAgo datetime={group.lastUpdated} />
                          </h3>
                        </div>
                        <div className="flex justify-between items-center mr-4 ">
                          {group?.lastMessageType === "text" ? (
                            <p className=" font-robo text-sm opacity-70 ">
                              {truncate(group.lastMessage, 35)}
                            </p>
                          ) : group?.lastMessageType === "file" ? (
                            <div className="flex justify-between items-center">
                              <DocumentIcon className="h-4 w-4  right-0 cursor-pointer opacity-70" />
                              <p className=" text-xs font-robo ">File</p>
                            </div>
                          ) : group?.lastMessageType === "image" ? (
                            <div className="flex justify-between items-center">
                              <PhotographIcon className="h-4 w-4  right-0 cursor-pointer opacity-70" />
                              <p className=" text-xs font-robo ">Image</p>
                            </div>
                          ) : group?.lastMessageType === "video" ? (
                            <div className="flex justify-between items-center">
                              <VideoCameraIcon className="h-4 w-4   right-0 cursor-pointer opacity-70" />
                              <p className=" text-xs font-robo ">Video</p>
                            </div>
                          ) : group?.lastMessageType === "audio" ? (
                            <div className="flex justify-between items-center">
                              <MicrophoneIcon className="h-4 w-4   right-0 cursor-pointer opacity-70" />
                              <p className=" text-xs font-robo ">Audio</p>
                            </div>
                          ) : group.lastMessage &&
                            group?.lastMessageType?.includes("code") ? (
                            <div className="flex justify-between items-center opacity-70">
                              <CodeIcon className="h-4 w-4  right-0 cursor-pointer" />
                              <p className=" text-xs font-robo ">
                                {truncate(group.lastMessage, 15)}
                              </p>
                            </div>
                          ) : (
                            <p className=" text-xs"></p>
                          )}
                          {selectedRef.current !== group._id &&
                          checkUnread(group.unread) ? (
                            <div class=" h-2 w-2  border-white rounded-full bg-[#44ff00]  mr-4"></div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="flex flex-col justify-center items-center">
                <p className="text-primary text-xl  font-robo  mt-10">
                  No Groups Joined
                </p>
                <button
                  className="  bg-palette_color1 my-3 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-6 py-3 rounded shadow-sm hover:border hover:border-palette_color1 hover:shadow-lg  mr-1 mb-1 ease-linear transition-all duration-500"
                  type="button"
                  onClick={() => setShowModal(true)}
                >
                  Create new group
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default Groups;
